/**
 * Formats a client object for display in Autocomplete fields.
 * Indicates if the client is an Economic Group or belongs to one.
 *
 * @param {Object} option
 * @returns {string}
 */
export function getClienteOptionLabel(option) {
	if (!option) return "";

	const code = option.clienteErpId ? `${option.clienteErpId} - ` : "";
	const name = option.nomeFantasia || option.razaoSocial || "";

	if (option.isGrupoEconomico) {
		return `${code}${name} [GRUPO ECONÔMICO]`;
	}

	if (option.grupoEconomicoNome) {
		return `${code}${name} (${option.grupoEconomicoNome})`;
	}

	return `${code}${name}`;
}
